import{jsx as e,jsxs as t}from"react/jsx-runtime";import{Skeleton as o,styled as a}from"@mui/joy";import i from"@mui/joy/Stack";import r from"@mui/joy/Typography";var n=({label:a,children:n,gap:l=2,button:s,loading:d=!1,labelSkeletonWidth:p="140px",...m})=>t(i,{sx:{border:e=>`0.5px solid ${e.palette.isDarkMode?e.palette.neutral[350]:e.palette.neutral[300]}`,borderRadius:e=>e.spacing(1),padding:2,gap:l},...m,children:[t(i,{direction:"row",justifyContent:"space-between",alignItems:"center",sx:{width:"100%"},children:[a&&e(r,{level:"title-sm",fontWeight:600,textColor:"neutral.700",children:e(o,{variant:"text",loading:d,level:"title-sm",sx:{width:p,borderRadius:"8px"},children:!d&&a})}),s]}),n]}),l=a(i)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({theme:e})=>e.spacing(2)};
  & > * {
    flex: 1;
  }
`,s=a(i)`
  overflow: auto;
`;export{n as InfoBox,l as InfoBoxRow,s as InformationContainer};
//# sourceMappingURL=InfoBox.js.map